<template>
    <ListeBonLivraison/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ListeBonLivraison from "@/components/GesCom/BonLivraison/ListeBonLivraison.vue";
    export default defineComponent({
      name: "ListeBonLivraisonPage",
      components: {
        ListeBonLivraison,
      },
    });
  </script>